<script>
  import {styleVars} from '/helper'
  import Card from '/components/Atoms/Card.svelte'
  import Pill from '/components/Atoms/Pill.svelte'
  import Link from '/Atoms/Link'

  export let title, category, subtitle, sup, noshare = false, category_link = null

  // $: console.log($$slots.headercontent)

</script>

<Card flow paddingStyle="article">
  <div class="container">
    {#if category }
      <h3 class="category">
        {#if category_link}
          <Link link={category_link}>
            { category }
          </Link>
        {:else}
          { category }
        {/if}
      </h3>
    {/if}
    <div class="header">
      {#if sup}
        <h2 class="sup">
          { sup }
        </h2>
      {/if}
      {#if title}
        <h2 class="title">
          { title }
        </h2>
      {/if}
      {#if subtitle}
        <h4 class="subtitle">
          {subtitle}
        </h4>
      {/if}
    </div>
    {#if !!$$slots.headercontent}
      <div class="headercontent">
        <slot name="headercontent"/>
      </div>
    {/if}
    <div class="content">
      <slot />
    </div>
    {#if !noshare}
      <!--
        <div class="share">
          <Pill title="Share"></Pill>
          <Pill title="Print/Pdf"></Pill>
        </div>
      -->
    {/if}
  </div>
</Card>

<style lang="scss">

  .container {
    /*display: flex;
    flex-direction: column;
    justify-content: space-between;*/
    width: 100%;
    text-align: center;
  }
  
  .category {
    @include typo-grotesk-title-captions-20;
    color: $color-red;
    text-align: left;
  }

  .header {
    text-align: center;
    margin-top: 26px;
    margin-bottom: 26px;
  }

  .sup {
    @include typo-serif-small-caps-28;
    margin-bottom: 25px;
  }

  .category + .header > .sup {
    // padding-top: 21px;
  }

  .title {
    @include typo-serif-title-44;
  }

  .subtitle {
    @include typo-serif-title-44;
    font-style: italic;
  }

  .headercontent {
    @include typo-serif-text-28;
    margin-bottom: 28px;
  }

  .content {
    @include typo-grotesk-text-24;
    // padding-bottom: 36px;
    text-align: left;
  }

  .share {
    text-align: left;
  }

</style>